export interface QuotationManagementRfqSummary {
  status?: string | null
  responseCount?: number | null
}

const FINALIZED_STATUSES = new Set(['CLOSED', 'COMPLETED', 'FINALIZED', 'CANCELLED'])

/** The RFQ list response's responseCount is built from vendor quotation/quoted-invitation data. */
export const hasSubmittedVendorQuotation = (rfq: QuotationManagementRfqSummary): boolean =>
  Number(rfq.responseCount ?? 0) > 0

export const isQuotationSelectionFinalized = (rfq: QuotationManagementRfqSummary): boolean =>
  FINALIZED_STATUSES.has(String(rfq.status || '').trim().toUpperCase())

export const shouldShowInActiveQuotationManagement = (
  rfq: QuotationManagementRfqSummary
): boolean => hasSubmittedVendorQuotation(rfq) && !isQuotationSelectionFinalized(rfq)
